"use strict";

var Backbone = require("backbone");
var _ = require("underscore");
var $ = require("jquery");
var Router = require("./router");

var UrlUtil = require("@immanens-com/pv5js/common/utils/url-util");
require("@immanens-com/pv5js/common/utils/backbone-util");

var debug = require("debug")("app"); //https://github.com/visionmedia/debug

var STR = require("./strings"); // initialisation de la table des messages

require("./styles/reader.css");

/**
 * 
 */
var ReaderApp = function (options) {
    var T = this;

    T.pv5api = null;
    T.version = PACKAGE_VERSION;
    T.name = "pv5js-reader-bnd";
    T.lang = "fr";
    T.homeUrl = null;
    T.documentId = null;
    T.token = null;
    T.publicationId = null;
    T.useRouter = true;
    T.onPageChanged = null;
    T.onHomeClicked = null;
    T.onTrackingEvent = null;
    T.theme = "rbn-bnd";
    T.path = null;
    T.search = null; // {query: "Procédure SAUF pénal"}
    T.allowVecto = true; // en true par défaut le 25/11/2020 (+ blacklist côté serveur)
    T.vectoMinimalBandwidth = 8;
    T.currentUrl = null;
    
    // activate debug message, use debug=* for all messages
    var query_obj = UrlUtil.parseQueryString(window.location.search.replace("?", ""), ["debug"]);
    if (query_obj.debug == "true") {
        localStorage.debug = "*";
    } else if (query_obj.debug == "false") {
        delete (localStorage.debug);
    } else if (query_obj.debug) {
        localStorage.debug = query_obj.debug;
    }

    $.extend(true, T, options); // attention, c'est le deep extend de jquery qu'on utilise ici
    _.extend(T, Backbone.Events); // trigger stuff

    T.themeApi = T.pv5api;
   
    T.lang = STR.init(T.lang);

    T.webClipperMessage = T.webClipperMessage || STR.default_content_web_clipper_message;
    
    debug(T.name +" " + T.version);
    debug("debug enable " + localStorage.debug);

    T.router = new Router({
        app: this
    });

    if (T.useRouter) {

        var history_options;
        if (T.path) {
            history_options = {
                pushState: true,
                root: T.path
            };
        }

        Backbone.history.start(history_options);
    }
    else {
        T.router.reader(T.publicationId, T.documentId, T.page);
    }

};

ReaderApp.prototype.notify = function (data) {
    this.trigger("app:notify", data);
};

/**
 * désalloue tout ce qui a été créé
 */
ReaderApp.prototype.close = function () {
    var T = this;
    if (T.useRouter) {
        Backbone.history.stop();
    }
    T.router.app = null;
    T.router.close();
    T.router = null;
};

module.exports = ReaderApp;


//////////////////
// WEBPACK FOOTER
// ./src/reader-app.js
// module id = 15
// module chunks = 0